export const resetPadding = () => {
	/*
			Issue: Problem with BoC's main styles
			Solution: Reset main paddng styles for JuniorApp
			TODO: Fix and adjust BoC's main navigation styles
	*/
	const bocMainNavigation: HTMLDivElement | null =
		document.querySelector('.main-header');

	const bocMain: HTMLElement | null = document.querySelector('main');

	if (bocMain && bocMainNavigation) {
		bocMain.style.paddingTop = `${bocMainNavigation?.offsetHeight}px`;
	}
};
